export const PLAIN_HOMEPAGE_INSTANCES = ['wesco.partfiniti.com', 'wesco.partifax.com'];
